import NumberEntry from './number-entry.component.vue';

export { NumberEntry };
